module.exports = {"rechargeValueLabel":"Valor da Recarga","currency":"R$","disclaimer":"","button":"continue","titleModalError":"Ops.","descriptionModalError":"Recarga não autorizada. Consulte seu cartão ou tente novamente com outro cartão de crédito."}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/RechargePayment/data.json
// module id = 1853
// module chunks = 0